export const assessmentConstants = {
  A_FETCHING_GROUP_UAS: "A_FETCHING_GROUP_UAS",
  A_FETCHING_GROUP_UAS_SUCCESS: "A_FETCHING_GROUP_UAS_SUCCESS",
  A_FETCHING_GROUP_UAS_ERROR: "A_FETCHING_GROUP_UAS_ERROR",

  SET_ASSESSMENT_YEAR_INDICATOR: "SET_ASSESSMENT_YEAR_INDICATOR",

  A_ASSESSMENT_INITIALIZE: "A_ASSESSMENT_INITIALIZE",
  A_ASSESSMENT_INITIALIZE_SUCCESS: "A_ASSESSMENT_INITIALIZE_SUCCESS",
  A_ASSESSMENT_INITIALIZE_ERROR: "A_ASSESSMENT_INITIALIZE_ERROR",

  A_USER_ASSESSMENTS_INITIALIZE: "A_USER_ASSESSMENTS_INITIALIZE",
  A_USER_ASSESSMENTS_INITIALIZE_SUCCESS:
    "A_USER_ASSESSMENTS_INITIALIZE_SUCCESS",
  A_USER_ASSESSMENTS_INITIALIZE_ERROR: "A_USER_ASSESSMENTS_INITIALIZE_ERROR",

  GET_ASSESSMENT_SETS: "GET_ASSESSMENT_SETS",
  GET_ASSESSMENT_SETS_SUCCESS: "GET_ASSESSMENT_SETS_SUCCESS",
  GET_ASSESSMENT_SETS_FAILED: "GET_ASSESSMENT_SETS_FAILED",

  A_FETCHING_ANSWERS: "A_FETCHING_ANSWERS",
  A_FETCHING_ANSWERS_SUCCESS: "A_FETCHING_ANSWERS_SUCCESS",
  A_FETCHING_ANSWERS_ERROR: "A_FETCHING_ANSWERS_ERROR",

  UPDATE_ANSWER_ITEM: "UPDATE_ANSWER_ITEM",

  FETCH_VIDEO_STATUS_REQUEST: "FETCH_VIDEO_STATUS_REQUEST",
  FETCH_VIDEO_STATUS_SUCCESS: "FETCH_VIDEO_STATUS_SUCCESS",
  FETCH_VIDEO_STATUS_FAILURE: "FETCH_VIDEO_STATUS_FAILURE",

  UPDATE_TEST_VIDEO_STATUS_REQUEST: "UPDATE_TEST_VIDEO_STATUS_REQUEST",
  UPDATE_TEST_VIDEO_STATUS_SUCCESS: "UPDATE_TEST_VIDEO_STATUS_SUCCESS",
  UPDATE_TEST_VIDEO_STATUS_FAILURE: "UPDATE_TEST_VIDEO_STATUS_FAILURE",

  FETCH_STUDENT_UAS_REQUEST: "FETCH_STUDENT_UAS_REQUEST",
  FETCH_STUDENT_UAS_SUCCESS: "FETCH_STUDENT_UAS_SUCCESS",
  FETCH_STUDENT_UAS_FAILURE: "FETCH_STUDENT_UAS_FAILURE",

  DD_REFRESH_GUA: "DD_REFRESH_GUA",
  DD_REFRESH_GUA_SUCCESS: "DD_REFRESH_GUA_SUCCESS",
  DD_REFRESH_GUA_ERROR: "DD_REFRESH_GUA_ERROR",

  UPDATE_GUA_THRESHOLD_DATA: "UPDATE_GUA_THRESHOLD_DATA",
  UPDATE_GUA_THRESHOLD_DATA_SUCCESS: "UPDATE_GUA_THRESHOLD_DATA_SUCCESS",
  UPDATE_GUA_THRESHOLD_DATA_ERROR: "UPDATE_GUA_THRESHOLD_DATA_ERROR",

  FETCH_SELECTED_GROUPUA_DATA: "FETCH_SELECTED_GROUPUA_DATA",
  FETCH_SELECTED_GROUPUA_DATA_SUCCESS: "FETCH_SELECTED_GROUPUA_DATA_SUCCESS",
  FETCH_SELECTED_GROUPUA_DATA_ERROR: "FETCH_SELECTED_GROUPUA_DATA_ERROR",

  A_ASSESSMENT_SCORING_STATUS: "A_ASSESSMENT_SCORING_STATUS",
  A_ASSESSMENT_SCORING_STATUS_SUCCESS: "A_ASSESSMENT_SCORING_STATUS_SUCCESS",
  A_ASSESSMENT_SCORING_STATUS_ERROR: "A_ASSESSMENT_SCORING_STATUS_ERROR"
}
